module.exports = __webpack_public_path__ + "static/img/new_banner@2x.23d23118.jpg";